import { ViewDataService, WaHelperService } from 'world-archery-lib';
import { BaseService } from '../../shared/base.service';
import { WorldRecordsCategoriesComboStore } from 'src/app/common-page-components/stores/filters-store/world-records-combo-store';
import { HttpClient } from '@angular/common/http';
import { TextFilter } from '../../../common-page-components/stores/filters-store/filters-store';
import { GenericNewsStore } from 'src/app/common-page-components/stores/entities-store/generic-news-store';
import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../../../library/wa-services/view-data-service";
import * as i2 from "../../../library/wa-services/wa-helper-service";
import * as i3 from "@angular/common/http";
export class FiltersWorldRecordsService extends BaseService {
    constructor(views, helper, http) {
        super(views, helper);
        this.http = http;
        /**
         * The news store for get the world records news.
         *
         * @memberof FiltersWorldRecordsService
         */
        this.newsStore = new GenericNewsStore(this.http, environment.news_api.world_records);
        this.comboCategoryStore = new WorldRecordsCategoriesComboStore('Categories:', 'records-category-combo', this.http);
        this.comboText = new TextFilter('records-text-filter');
        this.filtersType = [
            this.comboText.filterInfo,
            this.comboCategoryStore.competitionDisciplinesRef.filterInfo,
            this.comboCategoryStore.individualTeamComboRef.filterInfo,
            this.comboCategoryStore.levelComboRef.filterInfo,
            this.comboCategoryStore.historicalComboRef.filterInfo,
            this.comboCategoryStore.filterInfo
        ];
        this.newsStore.requestData({}, false).subscribe();
    }
    /**
     *
     * {@inheritdoc}
     * @returns
     * @memberof FiltersWorldRecordsService
     */
    generateDefaultValues() {
        return;
    }
}
FiltersWorldRecordsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FiltersWorldRecordsService_Factory() { return new FiltersWorldRecordsService(i0.ɵɵinject(i1.ViewDataService), i0.ɵɵinject(i2.WaHelperService), i0.ɵɵinject(i3.HttpClient)); }, token: FiltersWorldRecordsService, providedIn: "root" });
